(function() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (document.querySelector('.rain-overlay-canvas')) return;

  const canvas = document.createElement('canvas');
  canvas.className = 'rain-overlay-canvas';
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');

  let width = window.innerWidth;
  let height = window.innerHeight;

  // Set canvas size accounting for Device Pixel Ratio (Retina/High-DPI support)
  function resizeCanvas() {
    width = window.innerWidth;
    height = window.innerHeight;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    ctx.scale(dpr, dpr);
  }

  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  const activeDrops = [];
  const activeParticles = [];

  const maxDrops = 130;
  const wind = -0.6;

  class Drop {
    constructor() {
      this.reset();
      this.y = Math.random() * height;
    }

    reset() {
      this.x = Math.random() * (width + 120) - 60;
      this.y = -20;
      this.z = Math.random() * 3 + 0.5; // Depth factor: 0.5 to 3.5
      this.speed = (this.z * 4.5) + 11;
      this.length = (this.z * 3.5) + 5; // Shorter, more droplet-like
      this.opacity = (this.z * 0.12) + 0.04;
    }

    update() {
      this.y += this.speed;
      this.x += wind;

      // When hitting the bottom of viewport
      if (this.y >= height - 4) {
        // Spawn bounce particles
        const particleCount = Math.floor(Math.random() * 3) + 3; // 3 to 5 particles
        for (let i = 0; i < particleCount; i++) {
          activeParticles.push(new SplashParticle(this.x, height - 2, this.z));
        }
        this.reset();
      } else if (this.x < -60 || this.x > width + 60) {
        this.reset();
      }
    }

    draw() {
      ctx.beginPath();
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.x + wind * 0.3, this.y + this.length);
      ctx.strokeStyle = `rgba(174, 194, 224, ${this.opacity})`;
      ctx.lineWidth = this.z * 0.45;
      ctx.lineCap = 'round';
      ctx.stroke();
    }
  }

  class SplashParticle {
    constructor(x, y, z) {
      this.x = x;
      this.y = y;
      this.z = z;
      // Bounce upwards (negative velocity) and spread horizontally
      this.vx = (Math.random() - 0.5) * (z * 1.5 + 1) + (wind * 0.5);
      this.vy = -(Math.random() * (z * 2 + 1.5) + 1);
      this.gravity = 0.22;
      this.opacity = (z * 0.15) + 0.15;
      this.fade = Math.random() * 0.03 + 0.02;
      this.size = Math.max(0.6, z * 0.45);
    }

    update() {
      this.x += this.vx;
      this.vy += this.gravity; // Gravity pull
      this.y += this.vy;
      this.opacity -= this.fade;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(174, 194, 224, ${this.opacity})`;
      ctx.fill();
    }
  }

  // Populate active drops
  for (let i = 0; i < maxDrops; i++) {
    activeDrops.push(new Drop());
  }

  let isPaused = false;
  document.addEventListener('visibilitychange', () => {
    isPaused = document.hidden;
  });

  function animate() {
    if (isPaused) {
      requestAnimationFrame(animate);
      return;
    }

    // Clear the screen using the CSS-logical size
    ctx.clearRect(0, 0, width, height);

    // Update & draw active drops
    for (let i = 0; i < activeDrops.length; i++) {
      activeDrops[i].update();
      activeDrops[i].draw();
    }

    // Update, draw, and clean up splash particles
    for (let i = activeParticles.length - 1; i >= 0; i--) {
      const p = activeParticles[i];
      p.update();
      if (p.opacity <= 0 || p.y > height) {
        activeParticles.splice(i, 1);
      } else {
        p.draw();
      }
    }

    requestAnimationFrame(animate);
  }

  animate();
})();
